// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j2Yno","toggle":"styles_toggle__h-eUK","preview":"styles_preview__15_R0"};